import { formatSuggestionForSubmission } from '../../methods/format-suggestion'

/**
 * API'ye göndermek için öneri güncelleme verilerini formatlar
 * @param {Object} suggestionData - Ham öneri verileri
 * @returns {Object} Formatlanmış öneri verileri
 */
export const formatData = (suggestionData) => {
  return formatSuggestionForSubmission(suggestionData)
}